export default {
  namespaced: true,
  state: {
    previousWorkspaceId: null,
    modals: {
      fixedJournalAccept: {
        target: null,
        remainingCapacity: null,
      }
    }
  },
  actions: {
    savePreviousWorkspaceId(context, workspaceId) {
      context.state.previousWorkspaceId = workspaceId
    },
    async setFixedJournalAcceptModalTarget(context, {materialGroup, remainingCapacity}) {
      context.state.modals.fixedJournalAccept.target = materialGroup
      context.state.modals.fixedJournalAccept.remainingCapacity = remainingCapacity
    },
    async unsetFixedJournalAcceptModalTarget(context, materialGroup) {
      context.state.modals.fixedJournalAccept.target = null
    },
  },
  getters: {
    previousWorkspaceId(state) {
      return state.previousWorkspaceId
    },
    fixedJournalAcceptModalTarget(state) {
      return state.modals.fixedJournalAccept.target
    },
    fixedJournalAcceptModalRemainingCapacity(state) {
      return state.modals.fixedJournalAccept.remainingCapacity
    },
  }
}
